// extracted by mini-css-extract-plugin
export default {"ContentWrapper":"KeOaH2EG","CardMainContent":"i1HXGRQL","PharmacyInformation":"NSoNYiAn","PharmacyName":"DEHgWXDI","LocationInformation":"PT0uOvNl"};